import React, { useState, useEffect } from 'react';
import { Table, Button, Drawer, KeyValuePairs, Badge, HelpPanel, Link, SplitPanel, Popover, Steps, ExpandableSection, FlashbarProps, Flashbar } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';


import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import Pagination from '@cloudscape-design/components/pagination';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { useStoreAdmin } from '../../../context/useStoreAdmin';


import { mdiCheckCircle, mdiClockAlert, mdiHelpCircleOutline, mdiLock, mdiMenuRight, mdiTimerSandFull } from '@mdi/js';
import Icon from '@mdi/react';
import { formatPhone } from '../../../commons/functions';

const pageSize = 20;
type Step = {
    status: "success" | "stopped" | "pending" | "info"; // adjust based on your UI
    header: string;
    details?: JSX.Element;
};
export const InvitationsAuthorizePage = () => {
    const storeAdmin = useStoreAdmin();

    const [pendingJobCreation, setPendingJobCreation] = useState(false);

    const [messages, setMessages] = useState<FlashbarProps.MessageDefinition[]>([]);
    const { JWT, setJWT } = useGlobalState();

    const [helpOpen, setHelpOpen] = useState(false);
    const [sideOpen, setSideOpen] = useState(false);

    const [btnAuths, setBtnAuths] = useState(true);
    const [selectedInvitations, setSelectedInvitations] = useState<string[]>([]);

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    const [selectedItems, setSelectedItems] = useState<UserInvitation[]>([]);
    const { setLoading } = useGlobalState();
    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filteringText, setFilteringText] = useState('');

    const [selectedRow, setSelectedRow] = useState<UserInvitation | null>(null);

    const [invitations, setInvitations] = useState<UserInvitation[]>([]);


    type UserInvitationGuest = {
        idInvitacionInvitadoAcceso: number,
        invitadoIdControl: number,
        acceso: string,
        invitado: string,
        idInvitacion: number,
        accesses: UserInvitationGuestAccess[],
    }

    type UserInvitationGuestAccess = {
        idInvitacionInvitado: number,
        invitadoIdControl: number,
        horaArribo: string,
    }

    type UserInvitation = {
        idInvitacion: number,
        invitacion: string,
        displayName: string,
        invitacionMovil: string,
        fechaIngreso: string,
        horaIngreso: string,
        fechaInicio: string,
        horaInicio: string,
        fechaTermino: string,
        horaTermino: string,
        isAutorizada: number,
        SNPropiedad: string,
        idPropiedad: number,
        idUnidad: number,
        unidad: string,
        idControlInvitacion: number,
        hasStarted: number,
        hasEnded: number,
        isActive: number,
        allDay: number,
        passCode: string,
        direction: string,
        email: string,
        url: string,
        fechaInicioDia: number,
        fechaInicioMes: number,
        fechaInicioMesText: string
        fechaInicioShort: string,
        fechaTerminoShort: string,
        guests: UserInvitationGuest[],
    };

    const buildSteps = (data: any): Step[] => {
        if (!data?.guests) return [];

        return data.guests.map((guest: any): Step => ({
            status: "stopped",
            header: guest.invitado,
            details: (
                <Steps
                    steps={guest.access.map((acc: any): Step => ({
                        status: (acc.horaArribo !== "" ? "success" : "pending"),
                        header: acc.acceso,
                        details: (acc.horaArribo !== "" ? <span>Arribo: {acc.horaArribo}</span> : <span></span>),
                    }))}
                />
            ),
        }));
    };
    const handleCheckboxChange = (invitationId: string) => {
        setSelectedInvitations((prev) => {
            // If the access is already selected, remove it from the array, else add it
            if (prev.includes(invitationId)) {
                return prev.filter(id => id !== invitationId);
            } else {
                return [...prev, invitationId];
            }
        });
    };
    const filteredInvitations = invitations.filter(invitations => {
        const searchWords = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
        return searchWords.every(word =>
            invitations.displayName.toLowerCase().includes(word) ||
            invitations.invitacionMovil.toLowerCase().includes(word) ||
            invitations.unidad.toLowerCase().includes(word)
        );
    });

    const paginatedInvitations = filteredInvitations.slice(
        (currentPageIndex - 1) * pageSize,
        currentPageIndex * pageSize
    );

    //const handleSelectionChange = ({ detail }: UserInvitation) => {
    const handleSelectionChange = async (detail: any) => {
        console.log("TEST")
        console.log(detail.detail)

        setSelectedItems(detail.detail.selectedItems);
        setSelectedRow(detail.detail.selectedItems[0]);
        setHelpOpen(false);
        setSideOpen(true);
        //setBtnActionDisable(detail.selectedItems.length === 0);
        //if (detail.selectedItems.length > 1) setDrawerOpen(false);
    };

    useEffect(() => {
        setBtnAuths(selectedInvitations.length == 0)
    }, [selectedInvitations]); // The effect runs every time selectedAccesses changes

    // Handle row click to fetch additional data and open the HelpPanel
    const handleRowClick = async (rowData: UserInvitation) => {
        // Store selected row data
        try {
            setSelectedRow(rowData);
            setSelectedItems([rowData]);

        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setHelpOpen(false);
            setSideOpen(true);
        }
    };
    useEffect(() => {
    }, [selectedRow]);
    const handleAuth = async (idInvitacion: number) => {
        setSelectedItems([])
        setPendingJobCreation(true)
        setHelpOpen(false);
        setSideOpen(false);
        try {
            setLoading(true);
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/guests/authorize',
                    'JWT': JWT,

                },
                body: JSON.stringify({
                    idInvitacion: idInvitacion
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            storeAdmin(data);
            if (data.code === 0) {
                handleRefresh()
                setMessages([
                    {
                        type: 'success',
                        content: data.status,
                        id: 'error-msg',
                        dismissible: true,
                        onDismiss: () => setMessages([]),
                    },
                ]);
            } else {
                setMessages([
                    {
                        type: 'error',
                        content: data.status,
                        id: 'error-msg',
                        dismissible: true,
                        onDismiss: () => setMessages([]),
                    },

                ])
            }


        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
            setPendingJobCreation(false)
        }
    }
    const handleRefresh = async () => {
        setSelectedItems([])
        setPendingJobCreation(true)
        setHelpOpen(false);
        setSideOpen(false);
        try {
            setLoading(true);
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/guests/pending',
                    'JWT': JWT,

                },
                body: JSON.stringify({

                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            storeAdmin(data);
            if (data.code === 0) {
                setInvitations(data.invitations);
            }


        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
            setPendingJobCreation(false)
        }
    };


    useEffect(() => {
        //console.log(invitations)
    }, [invitations]);

    useEffect(() => {

        handleRefresh();
    }, []);

    if (JWT === '') {
        window.location.hash = '#user/login';
    }
    const handleHelp = async () => {
        setHelpOpen(!helpOpen)
    }
    return (
        <CustomAppLayout
            toolsOpen={helpOpen}
            onToolsChange={({ detail }) => setHelpOpen(detail.open)}
            splitPanelOpen={sideOpen}
            onSplitPanelToggle={({ detail }) => setSideOpen(detail.open)}

            tools={
                helpOpen && (
                    <HelpPanel
                        header={
                            <Header variant="h2">Ayuda</Header>
                        }
                    ><p>Las unidades que excedan la cantidad máxima de invitados, al momento de generar la invitación por parte del usuario, quedan pendientes de autorización por parte de la administración.</p>

                        <p>Este listado despliega todas las invitaciones las cuales no han finalizado y se encuentran pendientes de autorización. Para ver los detalles de la invitación y proceder a autorizar esta, haga click sobre la invitación en el listado</p>

                    </HelpPanel>
                )
            }
            splitPanel={
                selectedRow && (
                    <SplitPanel hidePreferencesButton header={`Notificación #${selectedRow.idInvitacion}`} closeBehavior='hide'>
                        <SpaceBetween direction='vertical' size='xs'>

                            <h3>{selectedRow.displayName}</h3>
                            <KeyValuePairs
                                columns={2}
                                items={[,
                                    {
                                        label: "Móvil",
                                        value: formatPhone(selectedRow.invitacionMovil),
                                    },
                                    {
                                        label: "Email",
                                        value: selectedRow.email,
                                    },
                                    selectedRow.invitacion !== '' ? {
                                        label: "Invitacion",
                                        value: selectedRow.invitacion
                                    } : null,
                                    selectedRow.allDay === 1 ? {

                                        label: "Extension",
                                        value: `${selectedRow.fechaTerminoShort} Todo el día`
                                    } : null,
                                    selectedRow.allDay === 0 && selectedRow.fechaTermino != selectedRow.fechaInicio ? {
                                        label: "Inicio",
                                        value: `${selectedRow.fechaInicioShort} ${selectedRow.horaInicio}`
                                    } : null,
                                    selectedRow.allDay === 0 && selectedRow.fechaTermino != selectedRow.fechaInicio ? {
                                        label: "Término",
                                        value: `${selectedRow.fechaTerminoShort} ${selectedRow.horaTermino}`
                                    } : null,
                                    selectedRow.allDay === 0 && selectedRow.fechaTermino === selectedRow.fechaInicio ? {
                                        label: "Duración",
                                        value: (
                                            <>
                                                {selectedRow.fechaTerminoShort} {selectedRow.horaInicio}
                                                {' '}<Icon path={mdiMenuRight} size={1} />{' '}
                                                {selectedRow.horaTermino}
                                            </>
                                        )
                                    } : null,
                                    {
                                        label: "Unidad",
                                        value: selectedRow.unidad,
                                    }
                                ].filter(Boolean) as { label: string; value: any }[]}
                            />
                            <Button variant="primary" onClick={() => handleAuth(Number(selectedRow.idInvitacion))}>Autorizar</Button>
                            {selectedRow.guests.length > 0 && (
                                <ExpandableSection headerText={`Invitados (${selectedRow.guests.length})`} defaultExpanded={selectedRow.guests.length <= 4}>
                                    <ul>
                                        {selectedRow.guests.map((item, index) => (
                                            <li key={index}>{item.invitado}</li>
                                        ))}
                                    </ul>
                                </ExpandableSection>
                            )}

                        </SpaceBetween>
                    </SplitPanel>
                )}

            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Invitaciones', href: '#invitations/default' },
                        { text: 'Pendientes de autorización', href: '#invitations' },
                        /*{ text: 'Listar notificaciones', href: '#create-transcription-job' },*/
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header
                            actions={
                                <SpaceBetween direction="horizontal" size="xs">
                                    <Button variant="primary" onClick={handleRefresh} loading={pendingJobCreation} iconName="refresh"></Button>
                                </SpaceBetween>
                            }
                            info={<Link onClick={handleHelp}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}
                        >
                            Autorizar invitaciones ({invitations.length})
                        </Header>
                        <Flashbar items={messages}></Flashbar>
                        <Table

                            stripedRows
                            loading={pendingJobCreation}
                            renderAriaLive={({ firstIndex, lastIndex, totalItemsCount }) =>
                                `Displaying items ${firstIndex} to ${lastIndex} of ${totalItemsCount}`
                            }
                            onSelectionChange={handleSelectionChange}
                            selectedItems={selectedItems}
                            onRowClick={({ detail }) => handleRowClick(detail.item)}
                            columnDefinitions={[
                                {
                                    id: "fechaInicio",
                                    header: "Desde",
                                    cell: (item) => `${item.fechaInicioShort} ${item.allDay === 0 ? item.horaInicio : ""}`
                                },
                                {
                                    id: "displayName",
                                    header: "Residente",
                                    cell: (item) => item.displayName,
                                    //sortingField: "displayName",
                                    isRowHeader: true,
                                },
                                {
                                    id: "unidad",
                                    header: "Unidad",
                                    cell: (item) => item.unidad,
                                    //sortingField: "unidad",
                                },
                                {
                                    id: "guests",
                                    header: "Invitados",
                                    cell: (item) => item.guests.length,
                                    maxWidth: 60,
                                    //sortingField: "unidad",
                                },
                                {
                                    id: "status",
                                    header: "Estado",
                                    maxWidth: 60,
                                    cell: (item) => {
                                        if (item.isAutorizada === 0) {
                                            return (
                                                <>
                                                    <Icon path={mdiLock} color="red" size={1}></Icon>
                                                </>
                                            );
                                        } else if (item.hasStarted === 0) {
                                            return (
                                                <>
                                                    <Icon path={mdiTimerSandFull} color={"critical-medium"} size={1}></Icon>
                                                </>
                                            );
                                        } else if (item.hasStarted === 1 && item.hasEnded === 0) {
                                            return (
                                                <>
                                                    <Icon path={mdiCheckCircle} color={"green"} size={1}></Icon>
                                                </>)
                                        } else if (item.hasEnded === 1) {

                                            return (
                                                <>
                                                    <Icon path={mdiClockAlert} color={"gray"} size={1} ></Icon>
                                                </>
                                            )
                                        }
                                        return null;
                                    },
                                    //sortingField: "unidad",
                                },
                            ]}
                            items={paginatedInvitations}
                            selectionType="single"
                            trackBy="idInvitacion"
                            empty={
                                <Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
                                    <SpaceBetween size="m">
                                        <b>No tiene invitaciones pendientes de autorización</b>
                                    </SpaceBetween>
                                </Box>
                            }
                            filter={
                                <TextFilter
                                    filteringText={filteringText}
                                    onChange={({ detail }) => {
                                        setFilteringText(detail.filteringText);
                                        setCurrentPageIndex(1);
                                    }}
                                />
                            }
                            pagination={
                                filteredInvitations.length > pageSize && (
                                    <Pagination
                                        currentPageIndex={currentPageIndex}
                                        pagesCount={Math.ceil(filteredInvitations.length / pageSize)}
                                        onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                    />
                                )}

                        />
                    </SpaceBetween>

                </>
            }
        />
    );
};
